import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { Component, OnInit, TemplateRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import * as jwt_decode from 'jwt-decode';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { ToastrService } from 'ngx-toastr';
import { ModuleName } from '../../services/coreService/contact.enum';
import { ContactsService } from '../../services/coreService/contacts.service';
import { ContactVm } from 'src/app/viewModels/core/contacts-vm';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-kanban-view',
  templateUrl: './kanban-view.component.html',
  styleUrls: ['./kanban-view.component.scss']
})
export class KanbanContactViewComponent implements OnInit {
  CCCList = [];
  colors=[
    {color:"#FD5B78"},
    {color:"#FF6037"},
    {color:"#FFFF66"},
    {color:"#66FF66"},
    {color:"#FC74FD"},
    {color:"#CCFF00"},
    {color:"#FF6EFF"},
    {color:"#E97451"},
    {color:"#E6BC5C"},
    {color:"#92926E"},
  ];
  connectedTo = [];
  currentUser: any;
  databaseId: string;
  organizationId: string;
  OfficeIDList: any = [];
  myOfficeID: any;
  folderID:number=0;
  pageModelData = {
    pageIndex: 0,
    pageSize: 20,
    searchValue: '',
  };
  archieved: boolean = false;
  responseHolder: any;
  SubmitColumnsButton: boolean = false;
  FieldColumnToogle:any=[]=[];
  showColumn:boolean=false;
  mainModuleName:string="";
  Module:string="";
  
  constructor(private dialog: MatDialog,private loaderService: LoaderService,
    private encryptionAlgo: EncryptionService, 
    private reusableClass: ReusableClasses,private contactVm: ContactVm,
    private statusConst: StatusConstant,
    private toastr: ToastrService,private contactService: ContactsService,
    private _dataSharingService: DataSharingService,private router: Router,) {
    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId');
    this.organizationId = sessionStorage.getItem('organizationID');
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
    this.currentUser = jwt_decode(token);
    var offices = JSON.parse(sessionStorage.getItem('officeList'));
    offices.forEach(oe => {
      this.OfficeIDList.push(oe.officeID);
      if (oe.isMyoffice == true)
        this.myOfficeID = oe.officeID;
    });
   }
 
  
  ngOnInit(): void {
    this.mainModuleName=ModuleName.Contact;   
    var menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));
    var Module=[];
    Module = menuModulesList.filter(x => x.mainModuleName == ModuleName.Contact);
    if(Module.length>0){
      this.Module = Module[0].orgModuleName;
      this.folderID = Module[0].folderID;        
     } 
     this.getListForShowColumn("");
     this.getListForShowRecord(""); 
     sessionStorage.setItem('HeaderModuleName', this.Module);
     this._dataSharingService.sendSelectedModuleName(this.Module);
  } 

  

  getListForShowRecord(searchKey: string) {   
    var ReqModel={
      pageIndex: this.pageModelData.pageIndex,
      pageSize : this.pageModelData.pageSize,
      databaseID: Number(this.databaseId),
      organizationID: Number(this.organizationId),
      userID: this.currentUser.UID,
      folderId : this.folderID,
      searchKey : "",
      userContactID : Number(sessionStorage.getItem('userContactID')),
      roleIDList : sessionStorage.getItem('roleIDList').split(','),
      officeIDList : this.OfficeIDList,
      officeID : this.myOfficeID,
      isArchived : this.archieved,
      isKanbanView : true,
     }   
    this.loaderService.show();
    this.contactService.getContactList(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.CCCList=[];
        this.connectedTo=[];
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {          
           var userKanbanViewColumn = this.responseHolder.data.userKanbanColumn;
           var defaultKanbanViewColumn = this.responseHolder.data.defaultKanbanColumn;
           if(userKanbanViewColumn==null && defaultKanbanViewColumn==null){
            this.showColumn=false;
           }else{
            this.showColumn=true;
            var data=[];
            data = this.responseHolder.data.defaultKanbanColumn;
            if(data.length>0){
              for (let i = 0; i < data.length; i++) {
               var isChecked=true;
                if(userKanbanViewColumn!=null){
                  var check=[];
                  check =userKanbanViewColumn.filter(x=>x.status.toLowerCase()==data[i].status.toLowerCase());
                  if(check.length>0){
                    isChecked=true;
                  }else{
                    isChecked=false;
                  }
                 }
                var reqmodel={
                  status: data[i],
                  isChecked: isChecked,
                }
                if(data[i]!=''){
                  this.FieldColumnToogle.push(reqmodel);
                }               
              }             
            }            
           }  
           
           var kanbanViewTransactions:any=[];          
           var transdata:any=[];
           kanbanViewTransactions = this.responseHolder.data.kanbanViewTransactions;
           if(kanbanViewTransactions!=null){
            kanbanViewTransactions=kanbanViewTransactions.filter(x=>x.status!="");   
            for (let i = 0; i < kanbanViewTransactions.length; i++){   
              var trans:any=[];
              trans = kanbanViewTransactions[i].transactions;
             
              if(trans.length>0){
                transdata=[];
                for (let i1 = 0; i1 < trans.length; i1++){
                  var feild=[];
                  var feildType=[];
                  feild= trans[i1].fields.filter(x=> x.fieldName=="Name");
                  let TypeID = 0;
                  feildType= trans[i1].fields.filter(x=> x.fieldName=="Type");
                  if(feildType.length>0){
                    TypeID=feildType[0].subFolderID;
                  }
                  var record={
                    id:trans[i1].contactID,
                    title:feild[0].fieldValue,
                    TypeID:TypeID,
                    createdOn:trans[0].createdOn,
                  }    
                  transdata.push(record);
                }                
              }else{
                transdata=[];
              }
                   
              var colorCode=[]; 
              colorCode= this.responseHolder.data.defaultKanbanColumn.filter(x=> x.status==kanbanViewTransactions[i].status);


               var obj={
                id:kanbanViewTransactions[i].status,
                datalist:transdata,
                color:colorCode[0].color,
                position:colorCode[0].position,
               }
               this.CCCList.push(obj);
            }
             for (let week of this.CCCList) {
              this.connectedTo.push(week.id);
             };
           }
           this.loaderService.hide();
        } else {
        }
      } else {
        this.loaderService.hide();
      }
    });
  }
 
  getListForShowColumn(searchKey: string) {
    var ReqModel={
      pageIndex: this.pageModelData.pageIndex,
      pageSize : this.pageModelData.pageSize,
      databaseID: Number(this.databaseId),
      organizationID: Number(this.organizationId),
      userID: this.currentUser.UID,
      folderId : this.folderID,
      searchKey : "",
      userContactID : Number(sessionStorage.getItem('userContactID')),
      roleIDList : sessionStorage.getItem('roleIDList').split(','),
      officeIDList : this.OfficeIDList,
      officeID : this.myOfficeID,
      isArchived : this.archieved,
      isKanbanView : true,
     }   
    this.loaderService.show();
    this.contactService.getContactList(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.FieldColumnToogle=[];
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {          
           var userKanbanViewColumn = this.responseHolder.data.userKanbanColumn;
           var defaultKanbanViewColumn = this.responseHolder.data.defaultKanbanColumn;
           if(userKanbanViewColumn==null && defaultKanbanViewColumn==null){
            this.showColumn=false;
           }else{
            this.showColumn=true;
            var data=[];
            data = this.responseHolder.data.defaultKanbanColumn;           
            if(data.length>0){             
              for (let i = 0; i < data.length; i++) {
               var isChecked=true;
                if(userKanbanViewColumn!=null){
                  var check=[];
                  check =userKanbanViewColumn.filter(x=>x.status.toLowerCase()==data[i].status.toLowerCase());
                  if(check.length>0){
                    isChecked=true;
                  }else{
                    isChecked=false;
                  }
                 }
                 var reqmodel={
                  status: data[i].status,
                  isChecked: isChecked,
                  color:data[i].color,
                  position:data[i].position
                }
                if(data[i]!=''){
                  this.FieldColumnToogle.push(reqmodel);
                }               
              }             
            }            
           }         
           this.loaderService.hide();
        } else {
        }
      } else {
        this.loaderService.hide();
      }
    });
  }

  customizeColumn(templateRef: TemplateRef<any>) {
    this.dialog.open(templateRef, {
      panelClass: 'custom-modalbox',
    });
    this.FieldColumnToogle=[];
    this.getListForShowColumn("");
    this.SubmitColumnsButton = false;
  }

  
  close() {
    this.SubmitColumnsButton = false;
    this.dialog.closeAll();
  }

 changedToggle(item, event) {
  this.FieldColumnToogle.find((x) => x.status.toLowerCase() == item.status.toLowerCase()).isChecked = event.checked;
  this.SubmitColumnsButton = true;
 }

 
 onSubmitColumns(){
  var kanbanViewColumns:any=[];
  if( this.FieldColumnToogle.length>0){
    var data=[];
    data  = this.FieldColumnToogle.filter(x=>x.isChecked==true);
    if(data.length>0){
       for (let i = 0; i < data.length; i++){
        var obj={
          status: data[i].status,
          color: data[i].color,
          position: data[i].position,
        }
        kanbanViewColumns.push(obj);
      }
      //kanbanViewColumns=kanbanViewColumns.replace(/,*$/, '');     
     } else{
    this.toastr.warning('Select atleast 1 column to show kanban view.', '', {
      timeOut: 3000,
    });
    return;
   }  
  }

  var ReqModel = {
    column:JSON.stringify(kanbanViewColumns),
    // kanbanViewColumn:kanbanViewColumns,
    folderID:this.folderID,
    userID: this.currentUser.UID,
    officeID: this.myOfficeID,
    organizationID: Number(this.organizationId),
  }
 // return;
  this.loaderService.show();
  this.contactService.addUserKanbanView(ReqModel).subscribe(response => {
    if (response != undefined) {
      this.loaderService.hide();
      this.responseHolder = response;    
      if (this.responseHolder.status == this.statusConst.statusSuccess) {
        this.toastr.success('Data added successfully.', '', {
          timeOut: 3000,
        });       
        this.close();
        this.getListForShowRecord("");
      }
      else {
        this.loaderService.hide();
      }
    }
    else {   
      this.loaderService.hide();  
    }
  });
  }

  
  drop(event: CdkDragDrop<string[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
      var record:any=[]=[];
      var selectedList:any=[]=[];
      var reOrdersList:any=[]=[];
      record =event.container.data;
      if(record.length>0){
        selectedList=[];  
        reOrdersList=[];      
        for (let i = 0; i < record.length; i++) {          
          selectedList.push(record[i].id);
          var obj1={
            cItemID: record[i].id,
            status: event.container.id,
            positionID: i+1
          }
          reOrdersList.push(obj1);
        }
        selectedList = selectedList.join(',');
        var selectedContactIdArray = selectedList.split(',').map(Number);

        var reqModel1={
          contactID:selectedContactIdArray,
          folderID: this.folderID,
          status:event.container.id,
          reOrders:reOrdersList,
          userID: this.currentUser.UID,
          organizationID: Number(this.organizationId),
          officeID: this.myOfficeID,
          databaseID: Number(this.databaseId)
        }
        this.loaderService.show();
        this.contactService.changeContactStatus(reqModel1).subscribe((response) => {
          if (response != undefined) {
            this.responseHolder = response;
            this.loaderService.hide();
            if (this.responseHolder.status == this.statusConst.statusSuccess) {          
              this.getListForShowRecord("");
            } else {
              this.loaderService.hide();
            }
          } else {
            this.loaderService.hide();
          }
        });
      }
    } else {
      transferArrayItem(event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex);

        var record:any=[]=[];
        var selectedList:any=[]=[];
        var reOrdersList:any=[]=[];
        record =event.container.data;
        if(record.length>0){
          selectedList=[];
          reOrdersList=[];    
          for (let i = 0; i < record.length; i++) {          
            selectedList.push(record[i].id);
            var obj1={
              cItemID: record[i].id,
              status: event.container.id,
              positionID: i+1
            }
            reOrdersList.push(obj1);
          }
          
          selectedList = selectedList.join(',');
          var selectedContactIdArray = selectedList.split(',').map(Number);

          var reqModel={
            contactID:selectedContactIdArray,
            folderID: this.folderID,
            status:event.container.id,
            reOrders:reOrdersList,
            userID: this.currentUser.UID,
            organizationID: Number(this.organizationId),
            officeID: this.myOfficeID,
            databaseID: Number(this.databaseId)
          }
          this.loaderService.show();
          this.contactService.changeContactStatus(reqModel).subscribe((response) => {
            if (response != undefined) {
              this.responseHolder = response;
              this.loaderService.hide();
              if (this.responseHolder.status == this.statusConst.statusSuccess) {          
                this.getListForShowRecord("");
              } else {
                this.loaderService.hide();
              }
            } else {
              this.loaderService.hide();
            }
          });
        }

       
    }
  }


  openDetails(cccItem:any){
    this.Module = "Contact";
    this.TransactionId = cccItem.id;  
    this.showDetail = !this.showDetail;
    // const id = cccItem.id;   
    //  if (cccItem.TypeID == null || cccItem.TypeID == undefined) {
    //      cccItem.TypeID = 0;
    //  }
    // sessionStorage.setItem('transactionID', id);
    // sessionStorage.setItem('TypeID', cccItem.TypeID);
    // sessionStorage.setItem('moduleName', "Contact");
    // this.router.navigate(['/contact/documents'], {});
    // this._dataSharingService.sendNextPreviousDocumentFromContact(false);
    // this._dataSharingService.sendNextPreviousForRightPanelFromContact(false);
    // this._dataSharingService.sendNextPreviousForTouchesFromContact(false);   
  }

  getCloseDetails(message){
    this.showDetail = false;
  }
  
  showDetail: boolean = false;
  TransactionId:number=0;
  columnname:string="";
  colorShow:boolean=false;

  showColor(ccc:any){
    this.colorShow=true;
    this.columnname=ccc.id;
  }

  closeColor(ccc:any){
    this.colorShow=false;
    this.columnname="";//ccc.id;
  }

  selectedColor(ccc:any,colors:any){    
    this.CCCList;
    var kanbanViewColumns:any=[];   
     if( this.CCCList.length>0){
       var data=[];
       data  = this.CCCList;
       if(data.length>0){
          for (let i = 0; i < data.length; i++){
            var color:string="";
            if(data[i].id==ccc.id){
              color=colors.color;
            }else{
              color=data[i].color;
            }
           var obj={
             status: data[i].id,
             color:color,
             position: data[i].position,
           }
           kanbanViewColumns.push(obj);           
         }          
        } 
      }
     var ReqModel = {
       column:JSON.stringify(kanbanViewColumns),    
       folderID:this.folderID,
       userID: this.currentUser.UID,
       officeID: this.myOfficeID,
       organizationID: Number(this.organizationId),
     }
     this.loaderService.show();
      this.contactService.addUserKanbanView(ReqModel).subscribe(response => {
       if (response != undefined) {
         this.loaderService.hide();
         this.responseHolder = response;    
         if (this.responseHolder.status == this.statusConst.statusSuccess) {         
          this.getListForShowRecord("");
         }
         else {
           this.loaderService.hide();
         }
       }
       else {   
         this.loaderService.hide();  
       }
     });

  }

  CCCListing() {
    sessionStorage.setItem('contactshowListing', 'true'); 
    sessionStorage.removeItem("contactshowkanban");
    sessionStorage.removeItem("contactshowGrouping");     
    this.router.navigate(['/contact/listing'], {});
    //sessionStorage.removeItem("contactshowkanban");     
    //this.router.navigate(['/contact/listing'], {});       
  }

  CCCKanban() {
    sessionStorage.setItem('contactshowkanban', 'true');
    sessionStorage.removeItem("contactshowListing");     
    sessionStorage.removeItem('contactshowGrouping');
    this.router.navigate(['/contact/kanbanview'], {});
   // sessionStorage.setItem('contactshowkanban', 'true');
   // this.router.navigate(['/contact/kanbanview'], {});  
  }

  CCCGridView(){
    sessionStorage.setItem("gridViewModuleName","Contact");
    sessionStorage.setItem("contactshowGrouping", 'true');    
    sessionStorage.removeItem('contactshowListing'); 
    sessionStorage.removeItem("contactshowkanban");
    this.router.navigate(['gridView']);   
    //this.router.navigate(['gridView']);   
  }
}
